import { z } from 'zod';
const I18nStringValidationSchema = z.object({
    english: z.string(),
    spanish: z.string().optional()
});
export { I18nStringValidationSchema };
//# sourceMappingURL=i18nString.js.map